import React from 'react';
import { MediaBaseUrl } from '../../../../../../../actions/api';
import ImageUpload from '../../../../../../CommonComponents/ImageUploader';


export default function ImageUploader({ image, uploadImg, name, heading }) {
    return (
        <div className="form-group image-upload-control">
            <label className='font-weight-bolder'>{heading}</label>
            <div className="">
                {!image ? <ImageUpload uploadPath={`media/tmpimages/`}  uploadAgents={["Instagram", "GoogleDrive", "Url", "Webcam"]} onImgUpload={(path) => uploadImg(path, name)}>
                    <div className="fc-uploader d-flex align-items-center justify-content-center">
                        <img src={`${MediaBaseUrl}dashboard/attah-logo.png`} alt="attah"/>
                        <span>Attach {name == 'logoImg' ? 'Logo' : 'Image'}</span>
                    </div>
                    </ImageUpload>:
                    <div className="fc-uploaded">
                        <div className="fc-uploaded-inn">
                            <span className="close" onClick={() => uploadImg(null, name)}><i className="fa fa-close"></i></span>
                            <img src={image} alt="user" />
                        </div>
                    </div>}
            </div>
        </div>
    )
}

